( function () {
    'use strict';
    e.dealersearch = {};
    e.dealersearch.settings = {
        fields: {
            jInput: jQuery( '#js-e-map-search-input' ),
            jSubmit: jQuery( '#js-e-map-search-submit' ),
            jReset: jQuery( '#js-e-map-search-reset' )
        },
        delay: {
            fast: 200,
            slow: 250
        }
    };
    e.dealersearch.primaryCountry = '';
    e.dealersearch.initialZoom = true;
    e.dealersearch.jDealerMap = null;
    e.dealersearch.typeahead = null;
    e.dealersearch.suggestIsAboutToFire = undefined;
    e.dealersearch.searchpositionMarker = undefined;
    e.dealersearch.datasource = [];
    /// Init dealer search logic
    e.dealersearch.init = function () {
        // Find dealersearch map
        var jGoogleMap = jQuery( '#js-e-map:visible' );
        e.dealersearch.jDealerMap = jGoogleMap;
        if ( jGoogleMap.length > 0 ) {
            // Read settings from map
            e.dealersearch.maxZoomLevelOnFitBounds = jGoogleMap.data( 'max-zoom-level' ) || 12;
            e.dealersearch.minSearchRadius = jGoogleMap.data( 'min-search-radius' ) || 20;
            // Determine country
            e.dealersearch.primaryCountry = e.dealersearch.determineCountry();
            // Attach events
            e.dealersearch.attachEvents();
            // Set focus in inputfield
            e.dealersearch.settings.fields.jInput.focus();
        }
    };
    /// Attach events to dom elements
    e.dealersearch.attachEvents = function () {
        e.dealersearch.bindTypeahead();
        // Search button
        e.dealersearch.settings.fields.jSubmit.on( 'click', function ( event ) {
            event.preventDefault();
            e.dealersearch.performSearch( e.dealersearch.settings.fields.jInput.val(), '', true );
        } );
        // Reset button
        e.dealersearch.settings.fields.jReset.on( 'click', function ( event ) {
            event.preventDefault();
            e.dealersearch.resetMap( {
                clearSearchfield: true
            } );
        } );
        // Event when map was dragged
        google.maps.event.addListener( e.dealersearch.jDealerMap.gmap( 'get', 'map' ), 'dragend', function () {
            // 300 ms after the center of the map has changed, pan back to the marker.
            window.setTimeout( function () {
                e.dealersearch.syncViewPort();
            }, 300 );
        } );
        // Event when zoom is changed
        google.maps.event.addListener( e.dealersearch.jDealerMap.gmap( 'get', 'map' ), 'zoom_changed', function () {
            // 300ms after the center of the map has changed, pan back to the marker.
            window.setTimeout( function () {
                e.dealersearch.syncViewPort();
            }, 300 );
            // When zoom changes, hook up to bounds changed, and override zoom level
            var zoomChangeBoundsListener = google.maps.event.addListenerOnce( e.dealersearch.jDealerMap.gmap( 'get', 'map' ), 'bounds_changed', function () {
                if ( this.getZoom() > e.dealersearch.maxZoomLevelOnFitBounds && e.dealersearch.initialZoom === true ) {
                    // Change max/min zoom here
                    this.setZoom( e.dealersearch.maxZoomLevelOnFitBounds );
                    e.dealersearch.initialZoom = false;
                }
                google.maps.event.removeListener( zoomChangeBoundsListener );
            } );
        } );
        // Listen to window resize
        e.constant.jWindow.on( 'resize', function () {
            e.dealersearch.resetMap();
        } );
    };
    e.dealersearch.markerClicked = function () {
        // Hide reset button
        e.dealersearch.settings.fields.jReset.removeClass( 'hidden' );
    };
    /// Determine primary country for search
    e.dealersearch.determineCountry = function () {
        // Determine primary country to append to each google request
        var prevCountry = '';
        jQuery( '.js-e-maps-country' ).each( function ( idx ) {
            var country = jQuery.trim( jQuery( this ).text() );
            // if all countries are not the same, return an empty string
            if ( idx > 0 && prevCountry !== country ) {
                prevCountry = '';
                return;
            }
            prevCountry = country;
        } );
        return prevCountry;
    };
    /// Render error when search fails
    e.dealersearch.renderNoResultsMessage = function ( message ) {
        var text = e.dealersearch.getNoResultsText( message );
        jQuery( '#js-e-maps-search-information-output' ).html( text );
    };
    /// Render error when search fails
    e.dealersearch.renderGoogleMapsError = function () {
        var errorText = jQuery( '#js-e-maps-search-information-error' ).html();
        jQuery( '#js-e-maps-search-information-output' ).html( errorText );
    };
    /// Clear error when search fails
    e.dealersearch.clearError = function () {
        jQuery( '#js-e-maps-search-information-output' ).html( '' );
    };
    e.dealersearch.getNoResultsText = function ( replaceText ) {
        var textPart1 = jQuery( '#js-e-maps-search-information-noresults-start' ).text(),
            textPart2 = jQuery( '#js-e-maps-search-information-noresults-end' ).text(),
            text = textPart1 + ' ' + replaceText + ' ' + textPart2;
        return text;
    };
    // Get URL for searchresult icon
    e.dealersearch.getSearchIconUrl = function ( jGoogleMap ) {
        var url = '//chart.googleapis.com/chart?chst=d_simple_text_icon_left&chld=|14|000|glyphish_target|24';
        var fill_color = jGoogleMap.data( 'settings' ).mapSearchIconColor;
        return url + '|' + fill_color;
    };
    /// Bind typeahead to field
    e.dealersearch.bindTypeahead = function () {
        e.dealersearch.typeahead = e.dealersearch.settings.fields.jInput.typeahead( {
            menu: '<ul class="typeahead nav dropdown-menu js-e-typeahead-dropdown"></ul>',
            source: function ( query, process ) {
                // Determine how fast we should start searching.
                var doFastSearch = false;
                // Test for zipcode
                var zipcodeRegex = /^[0-9]{4}/;
                if ( query.match( zipcodeRegex ) ) {
                    doFastSearch = true;
                }
                // Test for space 'Strøget 40'
                if ( query.indexOf( ' ' ) > 4 ) {
                    doFastSearch = true;
                }
                // Suggest with long words
                if ( query.length > 10 ) {
                    doFastSearch = true;
                }
                // Throttle
                if ( e.dealersearch.suggestIsAboutToFire ) {
                    clearTimeout( e.dealersearch.suggestIsAboutToFire );
                }
                e.dealersearch.suggestIsAboutToFire = setTimeout( function () {
                    e.dealersearch.performSearch( query, e.dealersearch.primaryCountry, false, function ( data ) {
                        return process( data );
                    }, false );
                }, doFastSearch ? e.dealersearch.settings.delay.fast : e.dealersearch.settings.delay.slow );
            },
            matcher: function ( item ) {
                return item;
            },
            updater: function ( item ) {
                // Show reset button
                e.dealersearch.settings.fields.jReset.removeClass( 'hidden' );
                e.dealersearch.performSearch( item, '', true, undefined, false );
                return item;
            }
        } );
    };
    /// Perform search
    e.dealersearch.performSearch = function ( originalSearchValue, appendToSearchValue, updateMap, callback, recursiveCall ) {
        // Clean up original search value for spaces and dirt
        var searchValueBeforeCountryAppend = originalSearchValue.replace( /[|&;$%@"<>()+, ]/g, '' );
        var searchValue = originalSearchValue;
        // Append country to searchvalue if we could determine a primary country
        if ( appendToSearchValue.length > 0 ) {
            searchValue = searchValueBeforeCountryAppend + ' ,' + appendToSearchValue;
        }
        if ( searchValueBeforeCountryAppend.length > 3 ) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode( {
                address: searchValue
            }, function ( results, status ) {
                if ( status === google.maps.GeocoderStatus.OK ) {
                    // Clear error message if it's being viewed
                    e.dealersearch.clearError();
                    var searchPosition = results[ 0 ].geometry.location;
                    // Update suggested addresses
                    e.dealersearch.datasource.length = 0;
                    for ( var i = 0; i < results.length; i++ ) {
                        e.dealersearch.datasource.push( results[ i ].formatted_address );
                    }
                    if ( updateMap ) {
                        // find marker closest to search address
                        var markersOnMap = e.dealersearch.jDealerMap.gmap( 'get', 'markers' );
                        var closestMarkers = e.dealersearch.helpers.findClosest( searchPosition, markersOnMap );
                        // remove all search markers
                        e.dealersearch.removeSearchMarkers();
                        // add search marker
                        var gMarkerOptions = {
                            bounds: true, // gmap specific
                            position: searchPosition,
                            icon: e.dealersearch.getSearchIconUrl( e.dealersearch.jDealerMap ),
                            zIndex: -1
                        };
                        e.dealersearch.addSearchMarker( gMarkerOptions );
                        // Clear bounds and fit search location and results in view
                        var bounds = new google.maps.LatLngBounds();
                        bounds.extend( searchPosition );
                        // Loop markers within range
                        jQuery.each( closestMarkers, function ( index, marker ) {
                            // Animate closest marker
                            marker.setAnimation( google.maps.Animation.DROP );
                            bounds.extend( marker.getPosition() );
                        } );
                        var map = e.dealersearch.jDealerMap.gmap( 'get', 'map' );
                        e.dealersearch.initialZoom = true;
                        map.fitBounds( bounds );
                        // Hide markers not visible on map
                        e.dealersearch.syncViewPort();
                        // Show reset button
                        e.dealersearch.settings.fields.jReset.removeClass( 'hidden' );
                    }
                    // Return result if a callback is present
                    if ( callback ) {
                        callback( e.dealersearch.datasource );
                    }
                }
                // If no results were found
                else if ( status === google.maps.GeocoderStatus.ZERO_RESULTS ) {
                    e.dealersearch.datasource.length = 0;
                    if ( recursiveCall === false ) {
                        e.dealersearch.performSearch( originalSearchValue, '', false, undefined, true );
                        return;
                    }
                    if ( updateMap ) {
                        e.dealersearch.renderNoResultsMessage( originalSearchValue );
                    }
                    // Reset viewport
                    e.dealersearch.resetMap();
                    if ( callback ) {
                        callback( e.dealersearch.datasource );
                    }
                }
                // Handle errors
                else if ( status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT ) {
                    e.dealersearch.renderGoogleMapsError();
                    e.dealersearch.helpers.trackInGoogle( 'Over query limit', searchValue );
                }
                else if ( status === google.maps.GeocoderStatus.ERROR ) {
                    e.dealersearch.renderGoogleMapsError();
                    e.dealersearch.helpers.trackInGoogle( 'Error', searchValue );
                }
                else if ( status === google.maps.GeocoderStatus.INVALID_REQUEST ) {
                    e.dealersearch.renderGoogleMapsError();
                    e.dealersearch.helpers.trackInGoogle( 'Invalid request', searchValue );
                }
                else if ( status === google.maps.GeocoderStatus.REQUEST_DENIED ) {
                    e.dealersearch.renderGoogleMapsError();
                    e.dealersearch.helpers.trackInGoogle( 'Request denied', searchValue );
                }
                else if ( status === google.maps.GeocoderStatus.UNKNOWN_ERROR ) {
                    e.dealersearch.renderGoogleMapsError();
                    e.dealersearch.helpers.trackInGoogle( 'Unknown error', searchValue );
                }
            } );
        }
        else {
            // Reset viewport
            e.dealersearch.resetMap();
        }
    };
    e.dealersearch.removeSearchMarkers = function () {
        var markersOnMap = e.dealersearch.jDealerMap.gmap( 'get', 'markers' );
        var bounds = new google.maps.LatLngBounds();
        // Fit bounds on all markers on map
        // - build new bounds that does not contain search marker
        // - make new list of markers that doesn't container search icon
        var newMarkerList = [];
        jQuery.each( markersOnMap, function () {
            if ( this.searchResult !== true ) {
                newMarkerList.push( this );
                bounds.extend( this.getPosition() );
            }
            else {
                this.setMap( null );
            }
        } );
        e.dealersearch.jDealerMap.gmap( 'set', 'bounds', bounds );
        e.dealersearch.jDealerMap.gmap( 'set', 'markers', newMarkerList );
    };
    e.dealersearch.addSearchMarker = function ( gMarkerOptions ) {
        // Add info to marker so we can find and remove it later
        gMarkerOptions.searchResult = true;
        e.dealersearch.jDealerMap.gmap( 'addMarker', gMarkerOptions, function ( /*map, marker*/) {} );
    };
    e.dealersearch.syncViewPort = function () {
        if ( e.dealersearch.resetInProgress !== true ) {
            // Hide list with dealers
            jQuery( '#js-e-map-list' ).removeClass( 'hidden' );
            // Hide all dealer list items
            jQuery( '.js-e-map-list-item' ).addClass( 'hidden' );
            // Hide alle dealer liste items that are not in view
            var markersOnMap = e.dealersearch.jDealerMap.gmap( 'get', 'markers' );
            var markersInView = 0;
            jQuery.each( markersOnMap, function () {
                var markerIsInView = e.dealersearch.jDealerMap.gmap( 'inViewport', this );
                if ( markerIsInView === true ) {
                    var jDealer = jQuery( this.dealer );
                    jDealer.removeClass( 'hidden' );
                    markersInView++;
                }
            } );
            // If no items in view, hide dealer list container
            if ( markersInView === 0 ) {
                jQuery( '#js-e-map-list' ).addClass( 'hidden' );
            }
        }
        e.dealersearch.resetInProgress = false;
    };
    e.dealersearch.resetMap = function ( options ) {
        // Hide list of dealers
        jQuery( '#js-e-map-list' ).addClass( 'hidden' );
        // Close all infowindows
        e.dealersearch.jDealerMap.gmap( 'closeInfoWindow' );
        // Remove search marker
        e.dealersearch.removeSearchMarkers();
        // Set variable to indicate if maps is being reset
        e.dealersearch.resetInProgress = true;
        // Hide reset button
        e.dealersearch.settings.fields.jReset.addClass( 'hidden' );
        if ( options !== undefined ) {
            if ( options.clearSearchfield === true ) {
                e.dealersearch.settings.fields.jInput.val( '' );
            }
        }
        // re-fit bounds of map
        e.dealersearch.jDealerMap.gmap( 'get', 'map' ).fitBounds( e.dealersearch.jDealerMap.gmap( 'get', 'bounds' ) );
        // Set focus in inputfield
        e.dealersearch.settings.fields.jInput.focus();
    };
    e.dealersearch.helpers = {};
    e.dealersearch.helpers.findRadius = function ( x ) {
        return x * Math.PI / 180;
    };
    e.dealersearch.helpers.findClosest = function ( source, markers ) {
        var markersWithinRange = [];
        var lat = source.lat();
        var lng = source.lng();
        var R = 6371; // radius of earth in km
        var distances = [];
        var closest = null;
        jQuery.each( markers, function ( index, marker ) {
            if ( marker.searchResult === undefined ) { // Skip markers that are not dealers
                var mlat = marker.getPosition().lat();
                var mlng = marker.getPosition().lng();
                var dLat = e.dealersearch.helpers.findRadius( mlat - lat );
                var dLong = e.dealersearch.helpers.findRadius( mlng - lng );
                var a = Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) + Math.cos( e.dealersearch.helpers.findRadius( lat ) ) * Math.cos( e.dealersearch.helpers.findRadius( lat ) ) * Math.sin( dLong / 2 ) * Math.sin( dLong / 2 );
                var c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) );
                var d = R * c;
                distances[ index ] = d;
                if ( closest === null || d < distances[ closest ] ) {
                    closest = index;
                }
            }
        } );
        // Distance to closest marker
        markersWithinRange.length = 0;
        var distanceToClosestMarker = distances[ closest ];
        var distanceToClosestMarkerWithFaktor = distanceToClosestMarker * 1.3;
        if ( distanceToClosestMarkerWithFaktor < e.dealersearch.minSearchRadius ) {
            distanceToClosestMarkerWithFaktor = e.dealersearch.minSearchRadius;
        }
        for ( var i = 0; i < markers.length; i++ ) {
            var markerDistanceToCenter = distances[ i ];
            if ( markerDistanceToCenter < distanceToClosestMarkerWithFaktor ) {
                markersWithinRange.push( markers[ i ] );
            }
        }
        //return markers[ closest ];
        return markersWithinRange;
    };
    e.dealersearch.helpers.trackInGoogle = function ( errorMessage, searchValue ) {
        if ( errorMessage || searchValue ) {
            //ga.trackEvent('','','');
        }
    };
} )();
